import CheckboxCore from '@mui/material/Checkbox';
import IconCheckboxChecked from 'assets/animator/checkbox-checked.inline.svg';
import IconCheckboxUnchecked from 'assets/animator/checkbox-unchecked.inline.svg';
import React from 'react';
import tw, { css } from 'twin.macro';

const cssCheckbox = css`
	${tw`p-0 w-14 h-14 sm:w-18 sm:h-18`};
`;

export default function Checkbox({ focusOnMount, loading, name, errorText, disabled, checked, ...props }) {
	return (
		<div>
			<CheckboxCore
				css={[ cssCheckbox ]}
				data-cy={props['data-cy'] ?? name}
				icon={<IconCheckboxUnchecked stroke={errorText ? '#d32f2f' : '#0A9E50'} />}
				checkedIcon={<IconCheckboxChecked />}
				inputRef={input => focusOnMount && input && input.focus()}
				disabled={loading || disabled}
				required={!!errorText}
				checked={checked}
				name={name}
				{...props}
			/>
		</div>
	);
}

Checkbox.defaultProps = {
	size: 'small'
};
